import { useState, useRef, useCallback, useEffect } from 'react';
import { type BlockedAction, installProtection } from '../model/protect';
import { EXAM } from '../model/exam-copy';

/**
 * Turn the copy deterrents on while the exam is on screen: handlers on `document`, a body flag
 * the print stylesheet reads, and a short notice (returned) for the last blocked action.
 */
export function useExamProtection(enabled: boolean): string | null {
  const [notice, setNotice] = useState<string | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const show = useCallback((what: BlockedAction) => {
    setNotice(EXAM.blocked[what]);
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => setNotice(null), 2500);
  }, []);
  useEffect(() => {
    if (!enabled) return;
    document.body.dataset.exam = '1';
    const off = installProtection(document, {
      onBlocked: show,
      clearClipboard: () => {
        try {
          void navigator.clipboard.writeText('').catch(() => undefined);
        } catch {
          /* clipboard not available */
        }
      },
    });
    return () => {
      off();
      delete document.body.dataset.exam;
      if (timer.current) clearTimeout(timer.current);
    };
  }, [enabled, show]);
  return enabled ? notice : null;
}
